import { useCallback } from "react"
import useApi from "./api"
import { useNavigate, useSearchParams } from "react-router-dom"
// import UAParser from "ua-parser-js"


export function useConsentValidator() {
    return (text)=>{

        if (!text) return false
        const regex = /^[a-zA-Z0-9]{6}$/
        
        return regex.test(text)
    }
}

export default function useConfigValidator() {
    let [searchParams] = useSearchParams()
    const token = searchParams.get("token")
    const company = searchParams.get("company")
    // const consentId = searchParams.get("consent")
    const { sendRequest } = useApi()
    const navigate = useNavigate()

    const getConfigs = useCallback(async () => {
        const path = `/iniciador/config-validation?token=${token}&company=${company}`
        const result = await sendRequest(path, 'GET')

        if (result.status === 401) {
            navigate("/error")
            return
        }

        return result

    }, [sendRequest, navigate, token, company])

    return { getConfigs }
}